(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  function enhanceGymEditorial(scope) {
    scope.querySelectorAll('.gs-editorial').forEach((root) => {
      const body = root.querySelector('.blog-post-content rte-formatter');
      if (!body || root.dataset.gsEnhanced) return;
      root.dataset.gsEnhanced = 'true';
      const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim() && !heading.closest('nav, aside'));
      const existingToc = body.querySelector('nav, #toc, .toc, .table-of-contents, #table-of-contents');
      if (headings.length >= 3 && !existingToc) {
        const nav = document.createElement('nav');
        nav.className = 'gs-editorial-nav';
        nav.setAttribute('aria-label', root.dataset.gsGuideLabel);
        const label = document.createElement('p');
        label.className = 'gs-editorial-nav-title';
        label.textContent = root.dataset.gsGuideLabel;
        const list = document.createElement('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            const base = `gs-guide-${index + 1}`;
            let id = base;
            let suffix = 1;
            while (document.getElementById(id)) id = `${base}-${suffix++}`;
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        nav.append(label, list);
        headings[0].before(nav);
      }
      body.querySelectorAll('table').forEach((table) => {
        if (table.closest('.gs-editorial-table')) return;
        const existingWrapper = table.parentElement.classList.contains('rte-table-wrapper');
        const wrapper = existingWrapper ? table.parentElement : document.createElement('div');
        wrapper.classList.add('gs-editorial-table');
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || root.dataset.gsTableLabel);
        const columns = Math.max(...[...table.rows].map((row) => [...row.cells].reduce((total, cell) => total + cell.colSpan, 0)), 1);
        wrapper.style.setProperty('--gs-table-min', `${Math.min(columns * 9, 60)}rem`);
        if (!existingWrapper) {
          table.before(wrapper);
          wrapper.append(table);
        }
        wrapper.tabIndex = wrapper.scrollWidth > wrapper.clientWidth + 1 ? 0 : -1;
      });
      const lastParagraph = [...body.querySelectorAll('p')].at(-1);
      if (lastParagraph && [...lastParagraph.querySelectorAll('a')].some((link) => {
        try {
          const url = new URL(link.href, document.baseURI);
          return url.hostname === location.hostname && /^(\/products\/|\/collections\/|\/$)/.test(url.pathname);
        } catch { return false; }
      })) lastParagraph.classList.add('gs-editorial-existing-merch');
    });
  }
  window.addEventListener('resize', () => {
    document.querySelectorAll('.gs-editorial-table').forEach((wrapper) => {
      wrapper.tabIndex = wrapper.scrollWidth > wrapper.clientWidth + 1 ? 0 : -1;
    });
  }, { passive: true });
  enhanceGymEditorial(document);
  document.addEventListener('shopify:section:load', (event) => enhanceGymEditorial(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
